import React, { useEffect, useState } from "react";
import * as cls from "./burnDownData.module.scss";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useSelector } from "react-redux";
import { StudentService } from "../studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import { ErrataView } from "../../../personal-studio-components/studio";

export default function BurnDownData() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [data, setData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  async function getBurnDownData() {
    const request = {
      method: "post",
      path: "/student/widget/burn_down_data",
      data: {
        access_token,
        study_contract_id: contractId,
        return_row_value: 0,
      },
    };

    await StudentService.send(request, (response) => {
      if (response) {
        setErrorMessage(response);
        if (!response.errors) {
          let burnDownData = response.burn_down_data.map((item) => ({
            ...item,
            burn_down_count: item.burn_down_count,
            zet_date: new Date(item.zet_date).getTime(),
          }));

          const groupedData = burnDownData.reduce((acc, item) => {
            if (!acc[item.zet_date]) {
              acc[item.zet_date] = { ...item, count: 1 };
            } else {
              acc[item.zet_date].burn_down_count += item.burn_down_count;
              acc[item.zet_date].count += 1;
            }
            return acc;
          }, {});

          burnDownData = Object.values(groupedData).map((item) => ({
            zet_date: item.zet_date,
            burn_down_count: item.burn_down_count / item.count,
          }));
          // console.log("первый", burnDownData);

          const avgData = [
            {
              zet_date: new Date(response.start_date).getTime(),
              avg: 0,
            },
            {
              zet_date: new Date(response.end_date).getTime(),
              avg: 100,
            },
          ];
          burnDownData = burnDownData.map((item, index) => ({
            ...item,
          }));
          burnDownData.push(avgData[0], avgData[1]);
          setData(burnDownData);
        } else {
          const errorEvent = new ErrorEvent("error", {
            error: response,
          });
          window.dispatchEvent(errorEvent);
          return;
        }
      }
    });
  }

  useEffect(() => {
    getBurnDownData();
  }, [contractId]);

  if (errorMessage && errorMessage.errors) {
    return (
      <>
        {errorMessage.error_type === "info" ? (
          <ErrataViewInfo errata={errorMessage} />
        ) : (
          <ErrataView errata={errorMessage} />
        )}
      </>
    );
  }
  if (data.length === 0) return null;
  return (
    <>
      <div className={cls.line_chart_wrapper}>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart
            width={600}
            height={350}
            data={data}
            margin={{ top: 5, right: 50, left: 10, bottom: 15 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="zet_date"
              type="number"
              scale="time"
              domain={["auto", "auto"]}
              tickFormatter={(tickItem) =>
                new Date(tickItem).toLocaleDateString("ru-RU")
              }
            />
            <YAxis
              domain={[0, 100]}
              label={{ value: "%", angle: -90, position: "insideLeft" }}
            />
            <Tooltip
              formatter={(value) => `${value}%`}
              labelFormatter={(label) =>
                `Дата: ${new Date(label).toLocaleDateString("ru-RU")}`
              }
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="burn_down_count"
              name="Ваш темп"
              stroke="#8884d8"
              activeDot={{ r: 6 }}
            />
            <Line
              type="monotone"
              dataKey="avg"
              name="Средний темп"
              stroke="#e30000"
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
}
